const FormIntro = (props) => {
    return (
        <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">{props.title}</h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">{props.subTitle}</p>
        </div>
    )
}

export default FormIntro